import React, { useState } from "react";

const DocumentViewer = (props) => {
    const { title, fileSrc } = props;
    return (
        <div style={{ width: "100%", }} className="viewerContainer">
            <div>
                <iframe
                    width="100%"
                    height="600px"
                    src={`https://docs.google.com/gview?url=${fileSrc}&embedded=true`}
                />
            </div>
        </div>
    );
};
export default DocumentViewer;